export class ThreeDsConfigurationFilterModel {
  public institution: string;
  public serviceContract: number;
  public channelType: string;
  public channel: string;
  public subChannel: string;
  public page: number;
  public size: string;
}
